<template>
  <div>
    <div class="operatingSystem-title">应用系统</div>
    <div class="operatingSystem-top">
      <operating-system-search></operating-system-search>
    </div>
    <table-operating-system></table-operating-system>
  </div>
</template>

<script>
import TableOperatingSystem from "../operating_system/TableOperatingSystem";
import OperatingSystemSearch from "../operating_system/OperatingSystemSearch";
export default {
  name: "OperatingSystem",
  components: {
    TableOperatingSystem,
    OperatingSystemSearch
  }
};
</script>

<style scoped>
.operatingSystem-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}
.operatingSystem-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/operating_system/OperatingSystem.vue